export type CustomIconsId =
  | "action-add-open"
  | "action-add"
  | "action-check"
  | "action-close"
  | "action-delete"
  | "action-edit"
  | "action-enter"
  | "action-export"
  | "action-pause"
  | "action-play"
  | "action-remove"
  | "action-save"
  | "action-search"
  | "arrows-back"
  | "arrows-down"
  | "arrows-full-down"
  | "arrows-left"
  | "arrows-right"
  | "arrows-up"
  | "data-aiq"
  | "data-bri"
  | "data-co2-produced"
  | "data-co2-saved"
  | "data-co2"
  | "data-cooling-network"
  | "data-cpow"
  | "data-electricity"
  | "data-enterprise"
  | "data-feel"
  | "data-furniture"
  | "data-heat-dec"
  | "data-heat-inc"
  | "data-hum"
  | "data-iot"
  | "data-ipow"
  | "data-occ"
  | "data-permanent-occupant"
  | "data-preview"
  | "data-solar-production"
  | "data-temperature-feel"
  | "data-tmp"
  | "icon-3d"
  | "icon-account"
  | "icon-applications"
  | "icon-cart"
  | "icon-indicators"
  | "icon-layers"
  | "icon-lightbulb"
  | "icon-lock"
  | "icon-menu-burger"
  | "icon-mosaic"
  | "icon-objects"
  | "icon-placeholder"
  | "icon-services"
  | "icon-settings"
  | "icon-shop";

export type CustomIconsKey =
  | "ActionAddOpen"
  | "ActionAdd"
  | "ActionCheck"
  | "ActionClose"
  | "ActionDelete"
  | "ActionEdit"
  | "ActionEnter"
  | "ActionExport"
  | "ActionPause"
  | "ActionPlay"
  | "ActionRemove"
  | "ActionSave"
  | "ActionSearch"
  | "ArrowsBack"
  | "ArrowsDown"
  | "ArrowsFullDown"
  | "ArrowsLeft"
  | "ArrowsRight"
  | "ArrowsUp"
  | "DataAiq"
  | "DataBri"
  | "DataCo2Produced"
  | "DataCo2Saved"
  | "DataCo2"
  | "DataCoolingNetwork"
  | "DataCpow"
  | "DataElectricity"
  | "DataEnterprise"
  | "DataFeel"
  | "DataFurniture"
  | "DataHeatDec"
  | "DataHeatInc"
  | "DataHum"
  | "DataIot"
  | "DataIpow"
  | "DataOcc"
  | "DataPermanentOccupant"
  | "DataPreview"
  | "DataSolarProduction"
  | "DataTemperatureFeel"
  | "DataTmp"
  | "Icon_3d"
  | "IconAccount"
  | "IconApplications"
  | "IconCart"
  | "IconIndicators"
  | "IconLayers"
  | "IconLightbulb"
  | "IconLock"
  | "IconMenuBurger"
  | "IconMosaic"
  | "IconObjects"
  | "IconPlaceholder"
  | "IconServices"
  | "IconSettings"
  | "IconShop";

export enum CustomIcons {
  ActionAddOpen = "action-add-open",
  ActionAdd = "action-add",
  ActionCheck = "action-check",
  ActionClose = "action-close",
  ActionDelete = "action-delete",
  ActionEdit = "action-edit",
  ActionEnter = "action-enter",
  ActionExport = "action-export",
  ActionPause = "action-pause",
  ActionPlay = "action-play",
  ActionRemove = "action-remove",
  ActionSave = "action-save",
  ActionSearch = "action-search",
  ArrowsBack = "arrows-back",
  ArrowsDown = "arrows-down",
  ArrowsFullDown = "arrows-full-down",
  ArrowsLeft = "arrows-left",
  ArrowsRight = "arrows-right",
  ArrowsUp = "arrows-up",
  DataAiq = "data-aiq",
  DataBri = "data-bri",
  DataCo2Produced = "data-co2-produced",
  DataCo2Saved = "data-co2-saved",
  DataCo2 = "data-co2",
  DataCoolingNetwork = "data-cooling-network",
  DataCpow = "data-cpow",
  DataElectricity = "data-electricity",
  DataEnterprise = "data-enterprise",
  DataFeel = "data-feel",
  DataFurniture = "data-furniture",
  DataHeatDec = "data-heat-dec",
  DataHeatInc = "data-heat-inc",
  DataHum = "data-hum",
  DataIot = "data-iot",
  DataIpow = "data-ipow",
  DataOcc = "data-occ",
  DataPermanentOccupant = "data-permanent-occupant",
  DataPreview = "data-preview",
  DataSolarProduction = "data-solar-production",
  DataTemperatureFeel = "data-temperature-feel",
  DataTmp = "data-tmp",
  Icon_3d = "icon-3d",
  IconAccount = "icon-account",
  IconApplications = "icon-applications",
  IconCart = "icon-cart",
  IconIndicators = "icon-indicators",
  IconLayers = "icon-layers",
  IconLightbulb = "icon-lightbulb",
  IconLock = "icon-lock",
  IconMenuBurger = "icon-menu-burger",
  IconMosaic = "icon-mosaic",
  IconObjects = "icon-objects",
  IconPlaceholder = "icon-placeholder",
  IconServices = "icon-services",
  IconSettings = "icon-settings",
  IconShop = "icon-shop",
}

export const CUSTOM_ICONS_CODEPOINTS: { [key in CustomIcons]: string } = {
  [CustomIcons.ActionAddOpen]: "61697",
  [CustomIcons.ActionAdd]: "61698",
  [CustomIcons.ActionCheck]: "61699",
  [CustomIcons.ActionClose]: "61700",
  [CustomIcons.ActionDelete]: "61701",
  [CustomIcons.ActionEdit]: "61702",
  [CustomIcons.ActionEnter]: "61703",
  [CustomIcons.ActionExport]: "61704",
  [CustomIcons.ActionPause]: "61705",
  [CustomIcons.ActionPlay]: "61706",
  [CustomIcons.ActionRemove]: "61707",
  [CustomIcons.ActionSave]: "61708",
  [CustomIcons.ActionSearch]: "61709",
  [CustomIcons.ArrowsBack]: "61710",
  [CustomIcons.ArrowsDown]: "61711",
  [CustomIcons.ArrowsFullDown]: "61712",
  [CustomIcons.ArrowsLeft]: "61713",
  [CustomIcons.ArrowsRight]: "61714",
  [CustomIcons.ArrowsUp]: "61715",
  [CustomIcons.DataAiq]: "61716",
  [CustomIcons.DataBri]: "61717",
  [CustomIcons.DataCo2Produced]: "61718",
  [CustomIcons.DataCo2Saved]: "61719",
  [CustomIcons.DataCo2]: "61720",
  [CustomIcons.DataCoolingNetwork]: "61721",
  [CustomIcons.DataCpow]: "61722",
  [CustomIcons.DataElectricity]: "61723",
  [CustomIcons.DataEnterprise]: "61724",
  [CustomIcons.DataFeel]: "61725",
  [CustomIcons.DataFurniture]: "61726",
  [CustomIcons.DataHeatDec]: "61727",
  [CustomIcons.DataHeatInc]: "61728",
  [CustomIcons.DataHum]: "61729",
  [CustomIcons.DataIot]: "61730",
  [CustomIcons.DataIpow]: "61731",
  [CustomIcons.DataOcc]: "61732",
  [CustomIcons.DataPermanentOccupant]: "61733",
  [CustomIcons.DataPreview]: "61734",
  [CustomIcons.DataSolarProduction]: "61735",
  [CustomIcons.DataTemperatureFeel]: "61736",
  [CustomIcons.DataTmp]: "61737",
  [CustomIcons.Icon_3d]: "61738",
  [CustomIcons.IconAccount]: "61739",
  [CustomIcons.IconApplications]: "61740",
  [CustomIcons.IconCart]: "61741",
  [CustomIcons.IconIndicators]: "61742",
  [CustomIcons.IconLayers]: "61743",
  [CustomIcons.IconLightbulb]: "61744",
  [CustomIcons.IconLock]: "61745",
  [CustomIcons.IconMenuBurger]: "61746",
  [CustomIcons.IconMosaic]: "61747",
  [CustomIcons.IconObjects]: "61748",
  [CustomIcons.IconPlaceholder]: "61749",
  [CustomIcons.IconServices]: "61750",
  [CustomIcons.IconSettings]: "61751",
  [CustomIcons.IconShop]: "61752",
};
